import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { findIndex } from 'rxjs/operators';
import { CoreService } from '../core/_services/core.services';

@Component({
  selector: 'app-evaluaciones',
  templateUrl: './evaluaciones.component.html',
  styleUrls: ['./evaluaciones.component.scss']
})
export class EvaluacionesComponent implements OnInit {

  @Input() requisicion: any;
  @Output() volver = new EventEmitter<any>();

  mostrarFormulario: boolean = false;
  evaluacionesLista: any[] = [];
  cargandoCompetencias: boolean = true;
  cargandoPuntuaciones: boolean = false;
  cargandoParticipantes: boolean = false;
  listaParticipantes: any[] = [];
  listaPuntuaciones: any[] = [];
  listaCompetencias: any[] = [];
  rowGroupMetadata: any;

  // Paginador Pendientes
  pageSize: Number = 10;
  cargoActual: any[];
  paginationOptions = {
    pageNumber: 1,
    rows: this.pageSize,
    pageLinkSize: 3,
    rowsPerPageOptions: [this.pageSize, 10, 15],
    totalRecords: 0
  };

  columnas: any[];

  nombreParticipantes: 'nombre';
  valores: any[] = [];
  opciones: any[] = [];
  observables: any[] = [];
  seleccion: any;
  numeroParticipantes: number = 0;

  objetoParametros: any = {
    titulo: 'Competencias E Indicadores',
    tituloEditables: 'Participantes',
    numeroOpciones: 5,
    tablas: [
      {
        cabecera: 'AutoControl',
        opciones: [
          {
            etiqueta: 'Controla sus emociones frente al estrés',
            codigo: 1
          },
          {
            etiqueta: 'Mantiene el dominio de la situación',
            codigo: 2
          },
          {
            etiqueta: 'Ignora acciones que le distraen de su objetivo',
            codigo: 1
          },
          {
            etiqueta: 'Es efectivo frente a la tensión de la situación',
            codigo: 1
          },
          {
            etiqueta: 'Evita actuar de forma impulsiva',
            codigo: 1
          },
          {
            etiqueta: '',
            codigo: 1
          }
        ]
      }
    ]
  }


  constructor(
    public coreService: CoreService
  ) { }

  ngOnInit(): void {
    this.cargaOpciones();
    this.getParticipantes();
    this.getPuntuaciones();
  }

  getObservables() {
    let params = {
      evaluacion_id: this.requisicion.id
    }
    this.cargandoCompetencias = true;
    this.coreService.getWithParams('/evaluacion-competencias', params).subscribe(
      (res: any[]) => {

        this.observables = res;
        this.listaCompetencias = res;
        let lista = [];
        let index = 0;
        res.forEach(competencia => {          
          competencia.observables.forEach(obs => {
            lista[index] = {
              observable: obs,
              competencia: competencia.competencia
            };
            let conteo = 1;
            for (let u = 0; u < this.listaParticipantes.length; u++) {
              lista[index]['nota' + conteo] = {
                valor: 1,
                participante: this.listaParticipantes[u].id
              }
              conteo++;
            }
            index++;
          });
        });
        this.cargaLabelCompetencias();
        this.opciones = lista;
      },
      (err: any) => {
        this.cargandoCompetencias = false;
        console.log(err);
      }
    )
  }

  getParticipantes() {
    let params = {
      evaluacion_id: this.requisicion.id
    }
    this.cargandoParticipantes = true;
    this.coreService.getWithParams('/evaluacion-candidatos', params).subscribe(
      (res: any[]) => {
        this.listaParticipantes = res;
        for (let index = 0; index < this.listaParticipantes.length; index++) {
          this.listaParticipantes[index]['codigo'] = index + 1;
        }
        this.cargandoParticipantes = false;
        this.getObservables();
        this.columnas = this.getColumnas();
      },
      (err: any) => {
        this.cargandoParticipantes = false;
        console.log(err);
      }
    )
  }

  getPuntuaciones() {
    this.cargandoPuntuaciones = true;
    /*
    let params = {
      evaluacion_id: this.requisicion.id
    }
    this.coreService.getWithParams('/evaluacion-categorias', params).subscribe(
      (res: any[]) => {
        this.listaPuntuaciones = res;
      },
      (err: any) => {
        console.log(err);
      }
    )
    */
    this.listaPuntuaciones = [
      {
        valor: 1,
        descripcion: 'Nunca presenta esta competencia'
      },
      {
        valor: 2,
        descripcion: 'Muy rara vez presenta esta competencia'
      },
      {
        valor: 3,
        descripcion: 'En algunas ocasiones presenta esta competencia'
      },
      {
        valor: 4,
        descripcion: 'Presenta esta competencia con relativa frecuencia'
      },
      {
        valor: 5,
        descripcion: 'Siempre presenta esta competencia'
      }
    ]

    this.cargandoPuntuaciones = false;
  }

  agregar() {
    this.mostrarFormulario = true;
  }

  clickVolver() {
    this.volver.emit();
  }

  guardar() {
    let params = {
      lista: JSON.stringify(this.listaNotas()),
      listaParticipantes: JSON.stringify(this.listaParticipantes)
    }
    this.coreService.getWithParams('/guardar-candidato-evaluacion', params).subscribe(
      (res: any[]) => {
        this.volver.emit();
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  listaNotas() {
    let lista: any = [];
    this.opciones.forEach(e => {
      let contador = 1;
      this.listaParticipantes.forEach(candidato => {
        lista.push({
          competencia_id: e.competencia.id,
          created_at: new Date(),
          updated_at: new Date(),
          calificacion: e['nota' + contador].valor,
          candidato_id: candidato.users_id,
          evaluacion_id: this.requisicion.id
        });
        contador++;
      });
    });
    return lista;
  }

  cargaOpciones() {
    this.valores = [];
    this.objetoParametros.tablas[0].opciones.forEach(o => {
      this.valores.push(o);
    });
    this.numeroParticipantes = this.valores.length;
  }

  trackByFn(index, item) {
    return index;
  }

  calculoSuma(participante, observable, indice) {
    let guia = this.opciones[indice];
    let total = 0;
    this.opciones.forEach(element => {
      if (element.competencia.id === guia.competencia.id) {
        if (element[ 'nota' + (observable.header)]) {
          total = total + element[ 'nota' + (observable.header)].valor;
        }
      }
    });
    return total;
  }

  getColumnas(): any[] {
    let objetoColumnas: any[] = [];
    let contador = 1;
    this.listaParticipantes.forEach(e => {
      objetoColumnas.push({
        idParticipante: e.id,
        header: contador,
        value: e.nota
      });
      contador++;
    });
    return objetoColumnas;
  }

  getIndex(data) {
    return this.listaParticipantes.findIndex(data);
  }

  cargaLabelCompetencias() {
    this.rowGroupMetadata = {};

    if (this.observables.length > 0) {
      for (let i = 0; i < this.observables.length; i++) {
        let nombreCompetencia = this.observables[i].competencia.des_referencia;
        if (i == 0) {
          this.rowGroupMetadata[nombreCompetencia] = { index: 0, size: this.observables[i].observables.length, posicionTotal: this.observables[i].observables.length };
        } else {
          this.rowGroupMetadata[nombreCompetencia] = { index: this.observables[i - 1].observables.length, size: this.observables[i].observables.length,  posicionTotal: this.observables[i - 1].observables.length + this.observables[i].observables.length };
        }
      }
    }
    this.cargandoCompetencias = false;
  }

  mostrarTotal(indice) {
    this.observables.forEach(e => {
      if(this.rowGroupMetadata[e.competencia.des_referencia].size == indice) {
        true;
      }
    });
  }

}

